



























































import Vue from 'vue';
import Dropdown from '@/components/Dropdown.vue';

export default Vue.extend({
  props: {
    value: [String, Array, Number],
    params: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { type } = this.params;
    const isOption = type && type === 'option';
    return {
      isOption,
    };
  },
  methods: {
    showOptions() {
      // dont do anything if readonly mode
      if (this.readonly) {
        return;
      }

      const {
        limit,
        title,
        values = {},
      } = this.params;
      const self = this;

      this.$store.commit('dialog/CREATE', {
        title,
        component: Vue.extend({
          data: () => ({
            isOption: this.isOption,
            value: this.value,
            options: values,
            limit,
          }),
          methods: {
            change(value: string | number | string[] | number[]) {
              self.$emit('input', value);
            },
          },
          components: {
            Dropdown,
          },
          template: `
            <dropdown
              v-model="value"
              :is-option="isOption"
              :limit="limit"
              :options="options"
              @close="$emit('close')"
              @input="change"
            />
          `,
        }),
      });
    },

    // method only for option type
    unselect(key: string) {
      const filtered = (this.value as string[]).filter(value => value !== key);
      this.$emit('input', filtered);
    },
  },
});
